import React from 'react';
import { MainTitle, MainTitleShowable } from '../../';
import PropTypes from 'prop-types';

export function ContentBlock(props) {
  const shadow = props.shadow ? 'main-shadow' : '';
  const renderTitle = () => {
    if (props.showable) {
      return (
        <MainTitleShowable
          visible={props.contentVisible}
          toggle={props.titleToggle}
          title={props.title}
        />
      );
    }

    if (props.title) {
      return (
        <MainTitle
          actions={props.actions}
          title={props.title}
          backAction={true}
        />
      );
    }
  };

  return (
    <div className={`${shadow} ${props.contentWrapper}`}>
      {renderTitle()}
      {props.contentVisible && <div className="main-comp-content">{props.children}</div>}
    </div>
  );
}

ContentBlock.propTypes = {
  blockWrapper: PropTypes.string,
  title: PropTypes.string,
  contentWrapper: PropTypes.string,
  children: PropTypes.any.isRequired,
  shadow: PropTypes.bool,
  iconsFirst: PropTypes.bool,
  showable: PropTypes.bool,
  contentVisible: PropTypes.bool,
  titleToggle: PropTypes.func,
  actions: PropTypes.array,
};

// TODO VYMAZAT vsade pouzivat collapsible block a kde sa nema collapse tam sa neda collapsible
export function AdminContentBlock(props) {
  return <div className="admin-content-block-wrapper">{props.children}</div>;
}
